<div *ngIf="isV2Form">
  <p-dialog
    modal="true"
    styleClass="atlas-dialog-m"
    position="top"
    [closable]="false" [(visible)]="showSubmissionModal"
  >
    <ng-template pTemplate="header">
      <h3 [wl-busy-overlay]="loading">{{ submissionResponse?.PrimaryProfile?.ReportName }} ({{ submissionResponse?.PrimaryProfile?.ProfileId }})</h3>
    </ng-template>
    <div [wl-busy-overlay]="loading">
      <div class="mb-27" *ngFor="let response of submissionResponse?.Dto.ElementResponses">
        <ng-template #t [ngTemplateOutlet]="t" let-templateElement [ngTemplateOutletContext]="{ $implicit: getTemplateElement(response) }">
          <div *ngIf="response.ElementType === elementType.SocialMedia"
               class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10">
            <label class="light-text mct-flex-0-1-150px">{{
              getSocialMediaLabel(response.SocialMediaData.SocialMediaTypeId)
            }}</label>
            <strong class="mct-flex-1-1-auto">{{ response.SocialMediaData.Value }}</strong>
          </div>
          <div *ngIf="response?.ElementType === elementType.MembershipLevel">
            <div *ngFor="let membershipLevel of response.MembershipLevelData"
                 class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10">
              <label class="light-text mct-flex-0-1-150px">{{
                'form-builder.form-submissions.form-submission-list.form-submission-view-modal.membership-level.label' | translate
              }}</label>
              <strong class="mct-flex-1-1-auto">{{ membershipLevel.DisplayName }}</strong>
            </div>
          </div>
          <div *ngIf="response?.ElementType == elementType.Listings">
            <div *ngFor="let listing of response.ListingData.Listings">
              <h4>
                {{ 'form-builder.form-submissions.form-submission-list.form-submission-view-modal.listing-title' | translate | titlecase }}
              </h4>
              <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="listing.CategoryID">
                <label class="light-text mct-flex-0-1-150px">{{
                  'form-builder.legos.listing.listing-category' | translate | titlecase
                }}</label>
                <strong class="mct-flex-1-1-auto">{{ getCategoryValue(listing.CategoryID) }}</strong>
              </div>
              <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="listing.SubCategoryID">
                <label class="light-text mct-flex-0-1-150px">
                  {{ 'form-builder.legos.listing.listing-subcategory' | translate | titlecase }}
                </label>
                <strong class="mct-flex-1-1-auto">{{ getSubCategoryValue(listing.SubCategoryID) }}</strong>
              </div>
              <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="listing.Descr">
                <label class="light-text mct-flex-0-1-150px">
                  {{ 'form-builder.legos.listing.long-description' | translate | titlecase }}
                </label>
                <strong class="mct-flex-1-1-auto">{{ listing.Descr }}</strong>
              </div>
              <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="listing.ShortDescr">
                <label class="light-text mct-flex-0-1-150px">
                  {{ 'form-builder.legos.listing.short-description' | translate | titlecase }}
                </label>
                <strong class="mct-flex-1-1-auto">{{ listing.ShortDescr }}</strong>
              </div>
              <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="listing.Keywords">
                <label class="light-text mct-flex-0-1-150px">
                  {{ 'form-builder.legos.listing.keywords' | translate | titlecase }}
                </label>
                <strong class="mct-flex-1-1-auto">{{ listing.Keywords }}</strong>
              </div>
            </div>
          </div>
          <div *ngIf="response?.ElementType == elementType.CustomField"
               class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10">
            <label class="light-text mct-flex-0-1-150px">
              {{ templateElement?.MetaData?.CustomFieldData?.Label }}
            </label>
            <strong class="mct-flex-1-1-auto">{{ response.CustomFieldData?.FieldValue }}</strong>
          </div>
          <div *ngIf="response?.ElementType == elementType.AffiliationCode"
               class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10">
            <label class="light-text mct-flex-0-1-150px">
              {{ templateElement?.MetaData?.AffiliationCodeData?.Label }}
            </label>
            <div class="mct-flex-1-1-auto">
              <p-checkbox disabled="true" [(ngModel)]="response.AffiliationCodeData.Selected" binary="true"> </p-checkbox>
            </div>
          </div>
          <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10"
            *ngIf="response?.ElementType === elementType.PurchaseItem && response.PurchaseItemData?.Selected">
            <label class="light-text mct-flex-0-1-150px">{{
              getTemplateElement(response)?.MetaData.PurchaseItemData.RevenueItemName
            }}</label>
            <strong class="mct-flex-1-1-auto">{{
              (getTemplateElement(response)?.MetaData.PurchaseItemData.Price ??
                getTemplateElement(response)?.MetaData.PurchaseItemData['CustomPrice']) | atlasCurrency
            }}</strong>
          </div>
          <div *ngIf="response?.ElementType === elementType.ProfileIndividual || response.ElementType == elementType.ProfileOrganization">
            <h4 *ngIf="response.ElementType === elementType.ProfileIndividual">
              {{
                'form-builder.form-submissions.form-submission-list.form-submission-view-modal.profile-individual-title'
                  | translate
                  | titlecase
              }}
            </h4>
            <h4 *ngIf="response?.ElementType === elementType.ProfileOrganization">
              {{
                'form-builder.form-submissions.form-submission-list.form-submission-view-modal.profile-org-title' | translate | titlecase
              }}
            </h4>
            <div *ngFor="let data of response?.ProfileData | keyvalue">
              <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="data.value">
                <label class="light-text mct-flex-0-1-150px">{{ getProfileLabel($any(data.key)) }}</label>
                <strong class="mct-flex-1-1-auto">{{ data.value }}</strong>
              </div>
            </div>
          </div>
          <div *ngIf="response?.ElementType === elementType.OpenField"
               class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10">
            <label class="light-text mct-flex-0-1-150px">{{ response.OpenFieldData?.Label }}</label>
            <strong class="mct-flex-1-1-auto">{{ response.OpenFieldData?.Value }}</strong>
          </div>
        </ng-template>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <div class="mct-flex mct-row mct-flex-lt-sm mct-col-lt-sm mct-justify-end mct-items-center mct-gap-10">
        <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="close()">
          <span>{{ 'common.done' | translate | uppercase }}</span>
        </button>
      </div>
    </ng-template>
  </p-dialog>
</div>

<div *ngIf="!isV2Form">
  <p-dialog
    modal="true"
    styleClass="atlas-dialog-m"
    position="top"
    [closable]="false" [(visible)]="showSubmissionModal"
  >
    <ng-template pTemplate="header">
      <h3 [wl-busy-overlay]="loading">{{ submissionResponse?.PrimaryProfile.ReportName }} ({{ submissionResponse?.PrimaryProfileId }})</h3>
    </ng-template>
    <div [wl-busy-overlay]="loading">
      <div *ngFor="let formGroup of submissionResponse?.Dto.FormGroups">
        <div *ngFor="let element of formGroup.GroupElements" class="mb-10">
          <!-- Default field types -->
          <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10"
            *ngIf="
              element.ElementTypeId !== 18 &&
              element.ElementTypeId !== 13 &&
              element.ElementTypeId !== 11 &&
              element.ElementTypeId !== 10 &&
              element.ElementTypeId !== 19 &&
              element.ElementTypeId !== 16 &&
              element.ElementTypeId !== 9 &&
              element.Field.FieldName !== 'Profile_Password'
            ">
            <label class="light-text mct-flex-0-1-150px">{{ element.LabelText }}</label>
            <strong class="mct-flex-1-1-auto">{{ element.Value }}</strong>
          </div>

          <div *ngIf="element.ElementTypeId === 11">
            <div *ngFor="let listing of element.Value">
              <h4>{{ element.LabelText }}</h4>
              <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="listing.PrimaryListing">
                <label class="light-text mct-flex-0-1-150px"><strong>{{ element.PrimaryListing.LabelText }}</strong></label>
                <strong class="mct-flex-1-1-auto">&nbsp;</strong>
              </div>
              <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="listing.CategoryID">
                <label class="light-text mct-flex-0-1-150px">{{ element.ListingCategory.LabelText }}</label>
                <strong class="mct-flex-1-1-auto">{{ getCategoryValue(listing.CategoryID) }}</strong>
              </div>
              <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="listing.SubCategoryID">
                <label class="light-text mct-flex-0-1-150px">{{ element.ListingSubCategory.LabelText }}</label>
                <strong class="mct-flex-1-1-auto">{{ getSubCategoryValue(listing.SubCategoryID) }}</strong>
              </div>
              <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="listing.Descr">
                <label class="light-text mct-flex-0-1-150px">{{ element.LongDescription.LabelText }}</label>
                <strong class="mct-flex-1-1-auto">{{ listing.Descr }}</strong>
              </div>
              <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="listing.ShortDescr">
                <label class="light-text mct-flex-0-1-150px">{{ element.ShortDescription.LabelText }}</label>
                <strong class="mct-flex-1-1-auto">{{ listing.ShortDescr }}</strong>
              </div>
              <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="listing.Keywords">
                <label class="light-text mct-flex-0-1-150px">{{ element.Keywords.LabelText }}</label>
                <strong class="mct-flex-1-1-auto">{{ listing.Keywords }}</strong>
              </div>
            </div>
          </div>

          <div *ngIf="element.ElementTypeId === 10">
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngFor="let socialMedia of element.Value">
              <label class="light-text mct-flex-0-1-150px">{{ socialMedia.Name }}</label>
              <strong class="mct-flex-1-1-auto">{{ getCategoryValue(socialMedia.Value) }}</strong>
            </div>
          </div>

          <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10"
               *ngIf="element.ElementTypeId === 16 && element.Value">
            <label class="light-text mct-flex-0-1-150px">{{ element.LabelText }}</label>
            <strong class="mct-flex-1-1-auto">{{ getMembershipLevel(element).Name }}</strong>
          </div>

          <div *ngIf="element.ElementTypeId === 13">
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10 mb-10">
              <label class="light-text mct-flex-0-1-150px"><strong>{{ element.LabelText }}</strong></label>
              <span class="mct-flex-1-1-auto">&nbsp;</span>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.Address1.Value">
              <label class="light-text mct-flex-0-1-150px">{{ element.Address1.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.Address1.Value }}</strong>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.Address2.Value">
              <label class="light-text mct-flex-0-1-150px">{{ element.Address2.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.Address2.Value }}</strong>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.City.Value">
              <label class="light-text mct-flex-0-1-150px">{{ element.City.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.City.Value }}</strong>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.State.Value">
              <label class="light-text mct-flex-0-1-150px">{{ element.State.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.State.Value }}</strong>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.Zip.Value">
              <label class="light-text mct-flex-0-1-150px">{{ element.Zip.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.Zip.Value }}</strong>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.County.Value">
              <label class="light-text mct-flex-0-1-150px">{{ element.County.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.County.Value }}</strong>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.Country.Value">
              <label class="light-text mct-flex-0-1-150px">{{ element.Country.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.Country.Value }}</strong>
            </div>
          </div>

          <div *ngIf="element.ElementTypeId === 19 && element.Value.length > 0">
            <h4>{{ element.LabelText }}</h4>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.Value[0].RelationTypeToMember">
              <label class="light-text mct-flex-0-1-150px">{{ element.RelationTypeToMember.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.Value[0].RelationTypeToMember }}</strong>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.Value[0].Title">
              <label class="light-text mct-flex-0-1-150px">{{ element.Title.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.Value[0].Title }}</strong>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.Value[0].Prefix">
              <label class="light-text mct-flex-0-1-150px">{{ element.Prefix.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.Value[0].Prefix }}</strong>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.Value[0].FirstName">
              <label class="light-text mct-flex-0-1-150px">{{ element.FirstName.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.Value[0].FirstName }}</strong>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.Value[0].MiddleInitial">
              <label class="light-text mct-flex-0-1-150px">{{ element.MiddleInitial.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.Value[0].MiddleInitial }}</strong>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.Value[0].LastName">
              <label class="light-text mct-flex-0-1-150px">{{ element.LastName.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.Value[0].LastName }}</strong>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.Value[0].Suffix">
              <label class="light-text mct-flex-0-1-150px">{{ element.Suffix.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.Value[0].Suffix }}</strong>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.Value[0].OrgName">
              <label class="light-text mct-flex-0-1-150px">{{ element.OrgName.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.Value[0].OrgName }}</strong>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.Value[0].Address1">
              <label class="light-text mct-flex-0-1-150px">{{ element.Address1.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.Value[0].Address1 }}</strong>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.Value[0].Address2">
              <label class="light-text mct-flex-0-1-150px">{{ element.Address2.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.Value[0].Address2 }}</strong>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.Value[0].City">
              <label class="light-text mct-flex-0-1-150px">{{ element.City.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.Value[0].City }}</strong>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.Value[0].State">
              <label class="light-text mct-flex-0-1-150px">{{ element.State.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.Value[0].State }}</strong>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.Value[0].Zip">
              <label class="light-text mct-flex-0-1-150px">{{ element.Zip.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.Value[0].Zip }}</strong>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.Value[0].County">
              <label class="light-text mct-flex-0-1-150px">{{ element.County.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.Value[0].County }}</strong>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.Value[0].Country">
              <label class="light-text mct-flex-0-1-150px">{{ element.Country.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.Value[0].Country }}</strong>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.Value[0].Email">
              <label class="light-text mct-flex-0-1-150px">{{ element.Email.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.Value[0].Email }}</strong>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.Value[0].WorkPhone">
              <label class="light-text mct-flex-0-1-150px">{{ element.WorkPhone.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.Value[0].WorkPhone }}</strong>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.Value[0].CellPhone">
              <label class="light-text mct-flex-0-1-150px">{{ element.CellPhone.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.Value[0].CellPhone }}</strong>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.Value[0].Fax">
              <label class="light-text mct-flex-0-1-150px">{{ element.Fax.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.Value[0].Fax }}</strong>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.BillingContact.Visible">
              <label class="light-text mct-flex-0-1-150px">{{ element.BillingContact.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.Value[0].BillingContact }}</strong>
            </div>
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="element.ReceivesCommunication.Visible">
              <label class="light-text mct-flex-0-1-150px">{{ element.ReceivesCommunication.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ element.Value[0].ReceivesCommunication }}</strong>
            </div>
          </div>

          <div *ngIf="element.ElementTypeId === 9">
            <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngFor="let contact of element.Value">
              <label class="light-text mct-flex-0-1-150px">{{ element.LabelText }}</label>
              <strong class="mct-flex-1-1-auto">{{ contact.OrgInd ? contact.OrgName : contact.FirstName + ' ' + contact.LastName }}</strong>
            </div>
          </div>

          <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10"
               *ngIf="element.ElementTypeId === 1 && element.Field.FieldName == 'Profile_Password'">
            <label class="light-text mct-flex-0-1-150px">{{ element.LabelText }}</label>
            <strong class="mct-flex-1-1-auto">********</strong>
          </div>
        </div>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <div class="mct-flex mct-row mct-flex-lt-sm mct-col-lt-sm mct-justify-end mct-items-center mct-gap-10">
        <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="close()">
          <span>{{ 'common.done' | translate | uppercase }}</span>
        </button>
      </div>
    </ng-template>
  </p-dialog>
</div>
